import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Icon from '../components/Icon';
import { LogoMark } from '../components/Logo';
import { countries, testimonials, howItWorksSteps, contactInfo } from '../mock';
import { trackCtaClick, trackCallClick } from '../lib/analytics';

const homeAgencyBullets = [
  'Up to 15% commission structure',
  'Dedicated account manager',
  'Marketing materials provided',
  'CRM access for tracking',
  'Fast-track visa processing',
];
const homeAgentBullets = [
  'Earn on every placement',
  'No investment required',
  'Flexible working hours',
  'Training & certification',
  'Performance incentives',
];

const HomePage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen" style={{ background: 'var(--zg-bg)' }}>
      {/* Hero */}
      <section className="relative overflow-hidden px-6" style={{ padding: '132px 24px 96px', background: 'var(--zg-surface)' }}>
        <LogoMark
          size={560}
          extraRing
          opacity={0.07}
          style={{ position: 'absolute', right: -130, top: 20, pointerEvents: 'none' }}
        />
        <LogoMark
          size={300}
          extraRing
          ink="#e08e0b"
          fill="#e08e0b"
          dotFill="#e08e0b"
          opacity={0.06}
          style={{ position: 'absolute', left: -110, bottom: -90, pointerEvents: 'none' }}
        />
        <div className="relative mx-auto max-w-7xl text-center">
          <span
            className="inline-flex items-center gap-2 text-[13px] font-semibold rounded-full px-[18px] py-2 mb-7"
            style={{ background: 'rgba(224,142,11,.15)', color: '#b5720a', animation: 'fadeIn .6s ease-out' }}
          >
            <span
              className="inline-block w-[7px] h-[7px] rounded-full"
              style={{ background: '#e08e0b', animation: 'pulse2 2s ease-in-out infinite' }}
            />
            1500+ Positions Available Across India &amp; Europe
          </span>

          <h1
            className="font-extrabold"
            style={{
              fontSize: 72,
              letterSpacing: '-0.03em',
              color: 'var(--zg-ink)',
              margin: '0 0 28px',
              lineHeight: 1.02,
            }}
          >
            Your <span style={{ color: '#e08e0b' }}>Dream</span> Career
            <br />
            Starts{' '}
            <span
              className="relative inline-block text-white"
              style={{ background: '#e08e0b', padding: '0 .28em', borderRadius: 14, transform: 'rotate(-2deg)' }}
            >
              Here
            </span>
          </h1>

          <p className="mx-auto max-w-2xl text-xl leading-relaxed mb-8" style={{ color: 'var(--zg-muted)' }}>
            Connect with premium job opportunities across India &amp; Europe. Earn up to ₹50,000/month in India or
            €2,500/month abroad with full support and benefits.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center pt-1 mb-12">
            <Link
              to="/partnership/agency"
              onClick={() => trackCtaClick('Agency Partnership', '/partnership/agency')}
              className="inline-flex items-center gap-2 h-[58px] px-[34px] rounded-full text-base font-bold text-black no-underline transition-all"
              style={{ background: '#e08e0b', boxShadow: '0 10px 24px rgba(224,142,11,.32)' }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.boxShadow = '0 14px 30px rgba(224,142,11,.4)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'none';
                e.currentTarget.style.boxShadow = '0 10px 24px rgba(224,142,11,.32)';
              }}
            >
              <Icon name="building" size={18} />
              <span>Agency Partnership</span>
              <Icon name="arrowRight" size={17} />
            </Link>
            <Link
              to="/partnership/agent"
              onClick={() => trackCtaClick('Agent Partnership', '/partnership/agent')}
              className="inline-flex items-center h-14 px-8 rounded-full text-base font-medium no-underline border transition-colors"
              style={{ background: 'var(--zg-card)', color: 'var(--zg-ink)', borderColor: 'var(--zg-ink)' }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = '#2d2a24';
                e.currentTarget.style.color = '#fff';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = 'var(--zg-card)';
                e.currentTarget.style.color = 'var(--zg-ink)';
              }}
            >
              <span className="inline-flex items-center gap-2">
                <Icon name="userCheck" size={18} />
                <span>Agent Partnership</span>
                <Icon name="arrowRight" size={17} />
              </span>
            </Link>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 max-w-4xl mx-auto">
            {[
              { label: 'Active Jobs', value: '1500+' },
              { label: 'Countries', value: '4+' },
              { label: 'Average Salary', value: '€1,900' },
              { label: 'Success Rate', value: '95%' },
            ].map((stat) => (
              <div
                key={stat.label}
                className="text-center rounded-[18px] border px-3 py-[22px] transition-all"
                style={{ background: 'var(--zg-card)', borderColor: 'var(--zg-border)', boxShadow: '0 8px 24px rgba(45,42,36,.06)' }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.style.boxShadow = '0 18px 40px rgba(45,42,36,.12)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'none';
                  e.currentTarget.style.boxShadow = '0 8px 24px rgba(45,42,36,.06)';
                }}
              >
                <div className="font-extrabold" style={{ fontFamily: "'Bricolage Grotesque',sans-serif", fontSize: 34, letterSpacing: '-0.02em', color: '#e08e0b' }}>
                  {stat.value}
                </div>
                <div className="text-[13px] mt-1.5" style={{ color: 'var(--zg-muted)' }}>
                  {stat.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Partner With Us */}
      <section className="relative overflow-hidden px-6" style={{ padding: '88px 24px', background: '#2d2a24', color: '#fff' }}>
        <LogoMark size={480} extraRing ink="#fff" fill="#fff" dotFill="#2d2a24" opacity={0.06} style={{ position: 'absolute', right: -100, bottom: -110, pointerEvents: 'none' }} />
        <div className="mx-auto max-w-7xl relative">
          <div className="text-center mb-16">
            <div className="text-[13px] font-bold uppercase mb-3" style={{ letterSpacing: '.14em', color: '#e08e0b' }}>
              Grow with us
            </div>
            <h2 className="text-5xl font-bold mb-4">Partner With Us</h2>
            <p className="text-xl max-w-2xl mx-auto" style={{ color: '#b4ae9f' }}>
              Join our growing network of agencies and agents. Unlock premium benefits and competitive commissions.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8">
            {[
              {
                icon: 'building',
                title: 'Agency Partnership',
                desc: 'Scale your recruitment business with our comprehensive support system',
                bullets: homeAgencyBullets,
                cta: 'Learn More →',
                to: '/partnership/agency',
              },
              {
                icon: 'userCheck',
                title: 'Agent Partnership',
                desc: 'Start earning with flexible hours and zero investment',
                bullets: homeAgentBullets,
                cta: 'Get Started →',
                to: '/partnership/agent',
              },
            ].map((card) => (
              <div
                key={card.title}
                className="rounded-[18px] p-8 transition-all"
                style={{ background: 'var(--zg-card)' }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.style.boxShadow = '0 26px 52px rgba(45,42,36,.16)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'none';
                  e.currentTarget.style.boxShadow = 'none';
                }}
              >
                <div
                  className="w-[54px] h-[54px] rounded-2xl flex items-center justify-center mb-[18px]"
                  style={{ background: 'rgba(224,142,11,.12)', color: '#c67e0a' }}
                >
                  <Icon name={card.icon} size={26} />
                </div>
                <div className="text-2xl font-bold mb-2" style={{ color: 'var(--zg-ink)' }}>
                  {card.title}
                </div>
                <p className="mb-6" style={{ color: 'var(--zg-muted)' }}>
                  {card.desc}
                </p>
                <ul className="list-none p-0 mb-6 flex flex-col gap-3">
                  {card.bullets.map((b) => (
                    <li key={b} className="flex gap-3" style={{ color: 'var(--zg-ink2)' }}>
                      <span style={{ color: 'var(--zg-ink)' }}>✓</span>
                      {b}
                    </li>
                  ))}
                </ul>
                <Link
                  to={card.to}
                  onClick={() => trackCtaClick(card.cta, card.to)}
                  className="flex items-center justify-center h-11 rounded-full text-[15px] font-medium text-white no-underline transition-all"
                  style={{ background: '#2d2a24' }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-2px)';
                    e.currentTarget.style.background = '#3a362e';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'none';
                    e.currentTarget.style.background = '#2d2a24';
                  }}
                >
                  {card.cta}
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Countries */}
      <section className="px-6" style={{ padding: '80px 24px' }}>
        <div className="mx-auto max-w-7xl">
          <div className="text-center mb-16">
            <div
              className="inline-flex items-center gap-3 rounded-full border mb-5"
              style={{ background: 'var(--zg-card)', borderColor: 'var(--zg-border)', padding: '7px 8px 7px 18px', boxShadow: '0 6px 20px rgba(45,42,36,.05)' }}
            >
              <span className="text-xs font-bold uppercase" style={{ letterSpacing: '.1em', color: 'var(--zg-muted2)' }}>
                Two continents
              </span>
              <span className="inline-flex items-center gap-1.5 rounded-full px-3 py-1" style={{ background: 'var(--zg-surface2)' }}>
                <span style={{ fontSize: 17, lineHeight: 1 }}>🇮🇳</span>
                <span style={{ color: '#c67e0a' }}>
                  <Icon name="arrowRight" size={15} />
                </span>
                <span style={{ fontSize: 17, lineHeight: 1 }}>🇪🇺</span>
              </span>
            </div>
            <h2 className="text-5xl font-bold mb-4" style={{ color: 'var(--zg-ink)' }}>
              Work Across India &amp; Europe
            </h2>
            <p className="text-xl max-w-2xl mx-auto" style={{ color: 'var(--zg-muted)' }}>
              Premium job opportunities in India and multiple European countries with competitive salaries
            </p>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {countries.map((country) => (
              <div
                key={country.name}
                className="rounded-[18px] border p-6 transition-all"
                style={{
                  borderColor: country.available ? 'var(--zg-border)' : '#ece6da',
                  opacity: country.available ? 1 : 0.6,
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.borderColor = '#e08e0b';
                  e.currentTarget.style.transform = 'translateY(-4px)';
                  e.currentTarget.style.boxShadow = '0 18px 40px rgba(45,42,36,.1)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.borderColor = country.available ? 'var(--zg-border)' : '#ece6da';
                  e.currentTarget.style.transform = 'none';
                  e.currentTarget.style.boxShadow = 'none';
                }}
              >
                <div className="flex items-center gap-2 text-2xl font-bold mb-2" style={{ color: 'var(--zg-ink)' }}>
                  <span className="text-4xl">{country.flag}</span>
                  {country.name}
                </div>
                {country.available ? (
                  <span className="inline-block text-xs rounded-full px-3 py-1 mb-4" style={{ background: '#dcfce7', color: '#166534' }}>
                    Hiring Now
                  </span>
                ) : (
                  <span
                    className="inline-block text-xs rounded-full px-3 py-1 mb-4 border"
                    style={{ color: 'var(--zg-muted)', borderColor: 'var(--zg-border2)' }}
                  >
                    Coming Soon
                  </span>
                )}
                <p className="mb-4" style={{ color: 'var(--zg-muted)' }}>
                  {country.description}
                </p>
                {country.available && (
                  <div className="flex flex-col gap-2 pt-2">
                    <div className="flex justify-between text-sm">
                      <span style={{ color: 'var(--zg-muted)' }}>Positions</span>
                      <span className="font-semibold" style={{ color: 'var(--zg-ink)' }}>
                        {country.totalPositions}+
                      </span>
                    </div>
                    <div className="flex justify-between text-sm">
                      <span style={{ color: 'var(--zg-muted)' }}>Avg. Salary</span>
                      <span className="font-semibold" style={{ color: 'var(--zg-ink)' }}>
                        {country.currency === 'EUR' ? '€' : '₹'}
                        {country.avgSalary}/month
                      </span>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* How It Works */}
      <section id="how-it-works" className="px-6" style={{ padding: '80px 24px' }}>
        <div className="mx-auto max-w-7xl">
          <div className="text-center mb-16">
            <div className="text-[13px] font-bold uppercase mb-3" style={{ letterSpacing: '.14em', color: '#b5720a' }}>
              Simple process
            </div>
            <h2 className="text-5xl font-bold mb-4" style={{ color: 'var(--zg-ink)' }}>
              How It Works
            </h2>
            <p className="text-xl max-w-2xl mx-auto" style={{ color: 'var(--zg-muted)' }}>
              Your journey to a great career in 5 simple steps
            </p>
          </div>

          <div className="grid md:grid-cols-3 lg:grid-cols-5 gap-8">
            {howItWorksSteps.map((step) => (
              <div key={step.step} className="text-center">
                <div
                  className="inline-flex items-center justify-center w-16 h-16 rounded-full text-white font-bold text-xl mb-4"
                  style={{ background: '#e08e0b' }}
                >
                  {step.step}
                </div>
                <h3 className="font-semibold mb-2" style={{ color: 'var(--zg-ink)' }}>
                  {step.title}
                </h3>
                <p className="text-sm" style={{ color: 'var(--zg-muted)' }}>
                  {step.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="px-6" style={{ padding: '80px 24px', background: 'var(--zg-surface)' }}>
        <div className="mx-auto max-w-7xl">
          <div className="text-center mb-16">
            <div className="text-[13px] font-bold uppercase mb-3" style={{ letterSpacing: '.14em', color: '#b5720a' }}>
              Testimonials
            </div>
            <h2 className="text-5xl font-bold mb-4" style={{ color: 'var(--zg-ink)' }}>
              Success Stories
            </h2>
            <p className="text-xl max-w-2xl mx-auto" style={{ color: 'var(--zg-muted)' }}>
              Hear from our community of successful candidates and partners
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {testimonials.map((testimonial) => (
              <div
                key={testimonial.id}
                className="rounded-[18px] border p-6 transition-all"
                style={{ borderColor: 'var(--zg-border)' }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.borderColor = '#e08e0b';
                  e.currentTarget.style.transform = 'translateY(-4px)';
                  e.currentTarget.style.boxShadow = '0 18px 40px rgba(45,42,36,.1)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.borderColor = 'var(--zg-border)';
                  e.currentTarget.style.transform = 'none';
                  e.currentTarget.style.boxShadow = 'none';
                }}
              >
                <div className="mb-4" style={{ color: 'var(--zg-ink)' }}>
                  ★★★★★
                </div>
                <p className="leading-relaxed mb-4" style={{ color: 'var(--zg-ink2)' }}>
                  "{testimonial.content}"
                </p>
                <div className="pt-4 border-t" style={{ borderColor: 'var(--zg-border)' }}>
                  <div className="font-semibold" style={{ color: 'var(--zg-ink)' }}>
                    {testimonial.name}
                  </div>
                  <div className="text-sm" style={{ color: 'var(--zg-muted)' }}>
                    {testimonial.role}
                  </div>
                  <div className="text-xs" style={{ color: 'var(--zg-muted2)' }}>
                    {testimonial.location}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section
        id="contact"
        className="relative overflow-hidden px-6 text-center"
        style={{ padding: '96px 24px', background: '#2d2a24', color: '#fff' }}
      >
        <span style={{ position: 'absolute', left: -110, top: -110, width: 360, height: 360, border: '1px solid #e08e0b', borderRadius: '50%', opacity: 0.16, pointerEvents: 'none' }} />
        <span style={{ position: 'absolute', right: -90, bottom: -130, width: 320, height: 320, border: '1px solid #fff', borderRadius: '50%', opacity: 0.06, pointerEvents: 'none' }} />
        <div className="mx-auto max-w-3xl relative">
          <h2 className="text-5xl font-bold mb-8">Ready to Start Your Journey?</h2>
          <p className="text-xl mb-8" style={{ color: '#b4ae9f' }}>
            Join thousands of successful candidates working across India &amp; Europe
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href={`tel:${contactInfo.phone}`}
              onClick={trackCallClick}
              className="inline-flex items-center h-14 px-8 rounded-full text-base font-medium no-underline transition-all"
              style={{ background: 'var(--zg-card)', color: 'var(--zg-ink)' }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.boxShadow = '0 12px 26px rgba(0,0,0,.22)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'none';
                e.currentTarget.style.boxShadow = 'none';
              }}
            >
              Call Us: {contactInfo.phone}
            </a>
            <a
              href={`mailto:${contactInfo.email}`}
              className="inline-flex items-center h-14 px-8 rounded-full text-base font-medium no-underline border border-white text-white transition-all"
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.boxShadow = '0 12px 26px rgba(0,0,0,.22)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'none';
                e.currentTarget.style.boxShadow = 'none';
              }}
            >
              Email: {contactInfo.email}
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HomePage;
